import React, { useMemo, useRef } from 'react';
import { useIntl } from 'umi';
import { Card } from 'tea-component';
import sortdown from '@/pages/intelligence/assets/svg/selectIcon/arrow-bottom.svg';
import {
  getRobloxTopChartsSortableColumnBySortKey,
  parseRobloxTopChartsSortListKey,
} from '../../config/robloxTopChartsSort';

import './index.scss';

interface IRobloxTopChartsSectionTitleProps {
  sortKey: string;
  sortOrder: 'asc' | 'desc';
  chart?: React.ReactNode;
}

const RobloxTopChartsSectionTitle: React.FC<IRobloxTopChartsSectionTitleProps> = ({
  sortKey,
  sortOrder,
  chart,
}) => {
  const { formatMessage } = useIntl();
  const cardRef = useRef<HTMLDivElement>(null);
  const { ratioType } = parseRobloxTopChartsSortListKey(sortKey);
  const sortColumn = getRobloxTopChartsSortableColumnBySortKey(sortKey);

  const metricTitle = useMemo(() => {
    if (!sortColumn?.labelKey) {
      return formatMessage({ id: 'dbi_roblox_top_charts_metric_section_title' });
    }

    return formatMessage({ id: sortColumn.labelKey });
  }, [formatMessage, sortColumn?.labelKey]);

  const sortedByText = useMemo(() => {
    const metricLabel = sortColumn?.labelKey
      ? formatMessage({ id: sortColumn.labelKey })
      : formatMessage({ id: 'dbi_roblox_top_charts_metric_pcu' });
    const sortField = ratioType === 1 ? `${metricLabel}(%)` : metricLabel;

    return formatMessage(
      { id: 'dbi_roblox_top_charts_sorted_by' },
      { sortField },
    );
  }, [formatMessage, ratioType, sortColumn?.labelKey]);

  return (
    <div ref={cardRef} className="dbi-roblox-top-charts-section-card-wrap">
      <Card className="dbi-mobileGames-card-context dbi-roblox-top-charts-section-card">
        <Card.Body
          title={
            <div className="dbi-roblox-top-charts-section-card__title">
              <span className="dbi-roblox-top-charts-section-card__title-text">
                {metricTitle}
              </span>
              <span className="dbi-details-text">
                {sortedByText}
                &nbsp;
                (
                <img
                  className="dbi-details-text-icon"
                  src={sortdown}
                  alt=""
                  style={sortOrder === 'asc' ? { transform: 'rotate(180deg)' } : undefined}
                />
                )
              </span>
            </div>
          }
        >
          {chart ? (
            <div className="dbi-roblox-top-charts-section-card__chart">
              {chart}
            </div>
          ) : null}
        </Card.Body>
      </Card>
    </div>
  );
};

export default RobloxTopChartsSectionTitle;
